import { useLocation } from 'react-router-dom';

import { Menu } from 'antd';
import { PatientRoutePrefix } from 'routes';

import { useAppSelector } from 'lib/store/rootReducer';

import { Role } from 'features/auth/types';
import {
  MenuItem,
  MENUITEMS_CLINICADMIN,
  MENUITEMS_CLINICIAN_GENERAL,
  MENUITEMS_GLOBALADMIN
} from './menu-config';
import { useClinicianPatientMenuInfo } from './useClinicianPatientMenuInfo';
import { HomeOutlined, TeamOutlined } from '@ant-design/icons';
import { theme } from 'styles/colors';

export function ClinicianMenu() {
  const location = useLocation();
  const clinicianPatientMenu = useClinicianPatientMenuInfo();

  const menuHighlightedRoute = clinicianPatientMenu.isMenuEnabled
    ? [
        PatientRoutePrefix,
        ':patientId',
        clinicianPatientMenu.match?.params.action
      ].join('/')
    : location.pathname;

  const user = useAppSelector(s => s.auth.user);
  const MENUITEMS: MenuItem[] = [
    user?.extraRole === Role.GlobalAdmin
      ? {
          key: 'global-admin',
          label: 'Global Admin',
          icon: <TeamOutlined style={{ color: theme.grey.medium }} />,
          children: MENUITEMS_GLOBALADMIN
        }
      : null,
    /**
     * Do not show the Admin options if the user is not an admin
     */
    user?.role === Role.ClinicAdmin
      ? {
          key: 'admin',
          label: 'Admin',
          icon: <TeamOutlined style={{ color: theme.grey.medium }} />,
          children: MENUITEMS_CLINICADMIN,
          disabled: user?.role !== Role.ClinicAdmin
        }
      : null,
    {
      key: 'general',
      label: 'General',
      icon: <HomeOutlined style={{ color: theme.grey.medium }} />,
      children: MENUITEMS_CLINICIAN_GENERAL
    }
  ];

  if (!user) return <></>;

  return (
    <Menu
      theme="light"
      mode="inline"
      selectedKeys={[menuHighlightedRoute]}
      defaultOpenKeys={['admin', 'general']}
      items={MENUITEMS}
    />
  );
}
